import Themes from "@/constants/themes-colors/Themes";

// #region Constants

// Cores principais para as linhas dos gráficos
const LightningBlue = "#77E0FF";
const Purple = "#8631DE";
const Orange = "#FF7F0A";
const Brown = "#C8736A";
const LightningGreen = "#6BFF6B";
const BrightPink = "#F137AE";
const BurntYellow = "#FBBC13";
const Blue = "#34ABFE";
export const Red = "#FF2A2A";

// Cores tema do Sistema.
export const AqtechThemes = Themes.AQTechThemeConfig.theme.themes;

// Cores para as linhas dos gráficos de pitch
export const lightModePitchChart = [ "#A4DA8D", "#5D7CD9" ];
export const darkModePitchChart = [ "#78DC4E", "#325CD9" ];

export const ChartLinesColorsDark = [ LightningBlue,
	Purple,
	Orange,
	Brown,
	LightningGreen,
	BrightPink,
	Red,
	BurntYellow,
	Blue,
];

// #endregion

// #region Methods

/**
 * @summary Adiciona a propriedade layout do gráfico as cores das linhas.
 * @type { Method }
 * @param {JSON} layout
 * @param {boolean} isDarkModeOn
 * @return {JSON} Layout com as cores das linhas.
 */
export const SetLayoutLinesColor = (layout, isDarkModeOn) =>
{
	const newLayout = layout;
	newLayout.xaxis.color = isDarkModeOn ?
	 Themes.AQTechThemeConfig.theme.themes.dark.secondary :
	 Themes.AQTechThemeConfig.theme.themes.light.info;

	newLayout.legend.font.color = isDarkModeOn ?
		Themes.AQTechThemeConfig.theme.themes.dark.secondary :
		Themes.AQTechThemeConfig.theme.themes.light.info;

	newLayout.yaxis.color = isDarkModeOn ?
		Themes.AQTechThemeConfig.theme.themes.dark.secondary :
		Themes.AQTechThemeConfig.theme.themes.light.info;

	return newLayout;
};

// #endregion
